import React from 'react';
import { LeaveBalance } from '../../shared/types.js';

interface LeaveBalanceCardProps {
    balance: LeaveBalance;
    index: number;
    onClick: () => void;
}

const LeaveBalanceCard: React.FC<LeaveBalanceCardProps> = ({ balance, index, onClick }) => {
    const secondaryPillColors = ['bg-blue-500', 'bg-green-600', 'bg-red-500', 'bg-yellow-500', 'bg-gray-500', 'bg-purple-500'];
    const pillColorClass = secondaryPillColors[index % secondaryPillColors.length];

    const displayName = balance.leaveTypeName.startsWith('Carryover') ? 'Carryover' : balance.leaveTypeName;

    return (
        <button
            onClick={onClick}
            className="bg-gray-200/50 dark:bg-gray-700/50 rounded-lg p-4 shadow-lg flex flex-col items-center justify-center text-center w-40 h-40 transition-transform duration-200 hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-brand-secondary"
        >
            <div className={`rounded-full px-4 py-1 text-sm font-bold text-white mb-2 truncate max-w-full ${pillColorClass}`} title={balance.leaveTypeName}>
                {displayName}
            </div>
            <div className="text-4xl font-bold text-gray-900 dark:text-white">{balance.available.toFixed(2)}</div>
            <div className="text-sm text-gray-500 dark:text-gray-400">Day(s) Available</div>
        </button>
    );
};

export default LeaveBalanceCard;
